<template>
<div class="body">
      <!-- 네비 -->
      <!-- <div class="main-navi">
         <div class="navi-wrap clear">
             <h1>
                 <a href="index">
                     <img src="../../assets/img/how/logo.png" alt="How 로고">
                 </a>
             </h1>
             <ul class="pc-navi">
               <li>
                     <a href="#" @click="is_login = true">로그인</a>
               </li>
            </ul>
             <a class="m-navi-btn pointer">
                 <i class="fas fa-bars" @click="is_mobile_menu = true"></i>
             </a>
             
         </div>
     </div> -->
     <div class="main-navi">
         <div class="navi-wrap clear">
             <h1>
                 <a href="/how_intro">
                     <!-- <img src="../../assets/img/how/how_logo.svg" alt="How 로고"> -->
                     <img src="../../assets/img/how/how_logo.svg" style="width: 150px;margin-top: 10px;"/> 
                 </a>
             </h1>
             <ul class="pc-navi">
               <li>
                     <span  style="cursor:pointer;"  @click="is_login = true">로그인</span>
               </li>
            </ul>
             <span class="m-navi-btn pointer" style="cursor:pointer;"  @click="is_login = true">
                로그인
             </span>
         </div>
     </div>
      <!-- 메인 비쥬얼 -->
      <div class="main-visual clear">
         <div class="wrap clear">
             <div class="how-title-wrap">
                 <h2>
                     Habit Of Writing
                 </h2>
                 <h3>
                     <!-- <img src="../../assets/img/how/how_logo.svg"/> -->
                     HOW는 행동주의 심리학의 습관 학습이론을 바탕으로한 <br>
                     Writing 역량 강화 프로그램입니다.
                 </h3>
             </div>
         </div>
         <div class="main-bg"></div>
      </div>

      <div class="index-con">
        <!-- How란?  -->
        <div class="wrap">
        <div class="how-test clear">
            <h3>HOW<span>(Habit of Writing) 란?</span></h3>
            <p>
                주어진 주제에 대해 글을 작성하고 전문 강사에 의해 체계적인 첨삭을 받아<br>
                Writing 실력을 향상시키는 1:1 Writing 훈련 프로그램입니다.
            </p>
            <ul class="mt-40">
                <li>
                    <img src="../../assets/img/how/how_con_01.png" alt="">
                    <div class="mt-30">
                        <p class="title">다양한 Writing 주제</p>
                        <p>
                            일반, 시사, 이메일, 프레젠테이션 등 <br>
                            학습자의 레벨, 목적에 맞는 다양한 토픽 제공
                        </p>
                    </div>
                </li>
                <li>
                    <img src="../../assets/img/how/how_con_02.png" alt="">
                    <div class="mt-30">
                        <p class="title">전문 강사의 1:1 첨삭</p>
                        <p>
                            체계적으로 훈련된 Writing 첨삭 전문 강사가<br>
                            학습자의 Writing 꼼꼼하게 교정하여 <br>
                            학습자에게 개선 방안 제안
                        </p>
                    </div>
                </li>
                <li>
                    <img src="../../assets/img/how/how_con_03.png" alt="">
                    <div class="mt-30">
                        <p class="title">포트폴리오 기능</p>
                        <p>
                            내가 쓴 글과 첨삭 내용은  <br>
                            언제든지 다시 확인해볼 수 있도록 <br>
                            My Class에서 안전한 스토리지 기능 제공
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        </div>

        <div class="how-to clear">
            <div class="wrap">
                <h3>편리한 HOW 학습 프로세스</h3>
                <div class="how-list">
                    <ul>
                        <li class="title">기본 문법에서 올바른 표현 활용 및 전체적인 맥락에 대한 교정까지!</li>
                        <li class="con-box">
                            <p>첨삭 전문강사의 꼼꼼하고 유익한 교정 피드백 제공</p>
                            <p class="how-to-img">
                                <img src="../../assets/img/how/how-to-img01.png" alt="">
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="how-list">
                    <ul>
                        <li class="title">주제 전개, 글의 구성, 문장구조, 문법 및 어휘 활용 등 5개 영역에 대한 평가 및 강사 코멘트!</li>
                        <li class="con-box">
                            <p>개인 맞춤 피드백 및 개선 방안 제공</p>
                            <p class="how-to-img">
                                <img src="../../assets/img/how/how-to-img02.png" alt="">
                            </p>
                        </li>
                    </ul>
                </div>
                
                <div class="how-list">
                    <ul>
                        <li class="title">첨삭 및 강사 품질 유지 및 관리!</li>
                        <li class="con-box">
                            <p>실시간 첨삭 만족도를 통한 신속한 품질관리 체계</p>
                            <p class="how-to-img">
                                <img src="../../assets/img/how/how-to-img03.png" alt="">
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 프로세스 -->
        <div class="how-process clear">
            <div class="wrap">
                <h3>편리한 HOW 학습 프로세스</h3>
                <ul>
                    <li>
                        <img src="../../assets/img/how/process_01.png" alt="">
                        <p class="title">학습 안내 메일 확인</p>
                    </li>
                    <li><img src="../../assets/img/how/process_arrow.png" alt=""></li>
                    <li>
                        <img src="../../assets/img/how/process_02.png" alt="">
                        <p class="title">토픽 확인 및 글쓰기</p>
                    </li>
                    <li><img src="../../assets/img/how/process_arrow.png" alt=""></li>
                    <li>
                        <img src="../../assets/img/how/process_03.png" alt="">
                        <p class="title">첨삭 확인 및 교정리뷰</p>
                    </li>
                    <li><img src="../../assets/img/how/process_arrow.png" alt=""></li>
                    <li>
                        <img src="../../assets/img/how/process_04.png" alt="">
                        <p class="title">평가 및 코멘트 확인</p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="how-index">
            <div class="wrap">
                <h3>한 눈에 보이는 HOW 학습</h3>
                <ul>
                    <li class="txt">
                        <p class="title bold">
                            간명하고 시스템화된 학습 플랫폼으로
                        </p>
                        <p class="sub">
                            PC뿐만 아니라 모바일에서도 <br>
                            간편하게 나의 학습 현황을 확인해 보세요!
                        </p>
                    </li>
                    <li class="phone-img">
                        <img src="../../assets/img/how/phone-img.png" alt="">
                    </li>
                </ul>
            </div>
        </div>

        <div class="how-class clear">
            <div class="wrap">
                <h3>HOW 과정 엿보기!</h3>
                <img src="../../assets/img/how/how-topic-img_new.png" alt="">
                <ul>
                    <li>
                        <p class="title bold">
                            일반 과정<br><span class="normal">(General Writing)</span>
                        </p>
                        <p class="sub normal">
                            다양한 일반 시사, 상식과 관련된 주제에 대한 <br>
                            <span class="bold">논리적이며 구조를 갖춘 에세이 작성능력 강화</span>
                        </p>
                    </li>
                    <li>
                        <p class="title bold">
                            비즈니스 과정<br> <span class="normal">(Biz Writing)</span>
                        </p>
                        <p class="sub normal">
                            이메일, 프레젠테이션, 협상 등 현업 적용 가능한 <br>
                            다양한 주제의 작문 훈련을 통해 논리적이며 설득력 있는 <br>
                            <span class="bold">비즈니스 커뮤니케이션 능력 확보 및 성공적인 글로벌 비즈니스 수행 견인</span>
                        </p>
                    </li>
                    <li>
                        <p class="title bold">
                            HOT News 과정<br><span class="normal">(News Topic Writing)</span>
                        </p>
                        <p class="sub normal">
                            영문 뉴스를 보고 main idea 및 본인의 의견 진술을 통해<br>
                            <span class="bold">요약 능력 및 이유와 근거를 기반으로 한 논리적인 글 작성 능력 강화 </span>
                        </p>
                    </li>
                    <li>
                        <p class="title bold">
                            자유 주제 과정<br><span class="normal">(Free Topic Writing)</span>
                        </p>
                        <p class="sub normal">
                            업무 또는 개인적으로 작성한 writing을 전문 강사의 교정을 통해 <br>
                            <span class="bold">다양한 형태의 글을 자연스럽고 올바른 표현으로 작성할 수 있는 능력 확보</span>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
      </div>

      <!-- 풋터 -->
      <div class="footer">
         <div class="wrap">
             <div class="call">
                 <div class="clear mb-05">
                     <div class="float-left">
                          <h3>CONTACT</h3>
                     </div>
                     <div class="float-right">
                         <select class="family_site" @change="linkChange($event)">
                             <option value="">Family Site</option>
                             <option value="http://www.carrotglobal.com/" target="_blank">CARROT HUB</option>
                             <option value="http://www.carrotenglish.kr" target="_blank">전화영어:모바일 화상</option>
                             <option value="http://www.carrotglobal.com/global/" target="_blank">기업교육:글로벌 역량</option>
                             <option value="http://www.carrotglobal.net" target="_blank">CARROT Global</option>
                             <option value="http://www.how-writing.com/how/main.php" target="_blank">HOW</option>
                             <option value="//www.thespac.net" target="_blank">SPAC</option>
                             <option value="//www.imooc.co.kr" target="_blank">i:MOOC</option>
                         </select>
                     </div>
                 </div>
                
                 <div class="call-con">
                     <p class="call_tell">
                         <img src="../../assets/img/how/foot_tel.png" alt="연락처" class="company_icon_tell"> 
                         <span class="company_info">02-518-2603</span> 
                     </p>
                     <p class="call_email mt-20">
                         <img src="../../assets/img/how/foot_mail.png" alt="메일" class="company_icon_email"> 
                         <span class="company_info">carrotwriting@carrotglobal.com</span> 
                     </p>
                     <p class="call_intro mt-20">
                         <img @click="newPage('https://www.carrotglobal.com/carrot/index.html')" src="../../assets/img/how/information.svg" alt="소개" class="company_icon_intro"> 
                         <span @click="newPage('https://www.carrotglobal.com/carrot/index.html')" class="company_info">회사소개</span> 
                     </p>
                     <!-- <p class="time"><span>상담시간</span>월~금 : 09:00AM~18:00PM</p>
                     <p>helphow@carrotglobal.com</p> -->
                 </div>
             </div>
             <div class="address">
                 <div class="how_logo">
                     <img class="how_logo_img" src="../../assets/img/how/footer_how_logo.svg">
                 </div>
                 <p>
                     서울특별시 서초구 강남대로 479 신논현타워 6F │ ㈜캐럿솔루션즈 대표이사 : 이은경 <br>
                     사업자등록번호: 357-87-02040 통신판매업신고번호 제 2021-서울강남-05384 호<span @click="private_go()" style="cursor:pointer"><br>
                    개인정보처리방침</span> · <span @click="terms()" style="cursor:pointer">이용약관</span> | Copyright © <span class="bold">CARROT</span> Inc. All Rights reserved.<br>
                 </p>
                 <div class="follow">
                     <span>FOLLOW US</span> : 
                     <img class="follow_icon" src="../../assets/img/how/sns1.png">
                     <img class="follow_icon" src="../../assets/img/how/sns2.png">
                     <img class="follow_icon" src="../../assets/img/how/sns3.png">
                 </div>
            </div>
         </div>
     </div>
     <!-- 로그인 레이어 팝업 -->
    <div class="how-layer-bg" v-if="is_login">
            <div class="how-layer">
                <a href="#" class="float-right layer-close" @click="is_login = false">
                    <img src="../../assets/img/how/layer_close.png" alt="">
                </a>
                <div class="top">
                    <h1><img src="../../assets/img/how/logo_on.png"></h1>
                    <p>HOW Writing 역량강화 센터에 오신걸 환영합니다! </p>
                </div>
                <div class="login-box">
                    <div class="login-form">
                        <input placeholder="ID(E-Mail)를 입력해 주세요." class="input-login" v-model="info.email">
                    </div>
                        <p class="txt-alert" v-if="is_err_id">ID(E-Mail)를 입력해 주세요.</p>
                    <div class="login-form">
                        <input placeholder="비밀번호를 입력해 주세요." class="input-login" v-model="info.pw" type="password">
                    </div>
                        <p class="txt-alert" v-if="is_err_pw">비밀번호를 다시 확인해 주세요.</p>
                    <div class="login-setting">
                        <input type="checkbox" class="login-check" v-model="is_save" @change="saveIdpw()"> 
                        <label for="stln" class="lab-check">ID/PW 기억하기</label>
                    </div>
                    <button class="btn-login" @click="doSubmit()">로그인</button>
                    <!-- <div class="login-rel">
                        <span href="retyrb fa" style="cursor: pointer;" @click="showPwpop()" data-toggle="modal" data-target="#passwordModal">비밀번호를 잊으셨나요?</span>
                    </div> -->
                </div>
            </div>
    </div>
    <PwPopupModal :visible="pwVisible" @close="vue_close"></PwPopupModal>
   </div>

   
</template>

<script>
import PwPopupModal from '../../components/pop_findPw.vue'

export default {
    name: 'HowIntro',
    components: {
        PwPopupModal
    },
    data: () => ({
        pwVisible: false,
        info: {
            email: "",
            pw: ""
        },
        is_err_id: false,
        is_err_pw: false,
        is_save: false,
        is_login:false,
        is_mobile_menu:false,
        msg: ""
    }),
    mounted() {
        //    this.doc_del_rendar();
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.is_save = false;
        if (localStorage.getItem("email") != null || localStorage.getItem("email") != "") {
            this.info.email = localStorage.getItem("email");
            this.info.pw = localStorage.getItem("pw");
            if(this.info.email == 'null'){
                this.info.email = '';
            }
            if(this.info.pw == 'null'){
                this.info.pw = '';
            }
            if(localStorage.getItem("is_save") == "1"){
                this.is_save = true;
            }else{
                this.is_save = false;
            }
        } else {
            this.info.email = "";
            this.info.pw = "";
            this.is_save = false;
            if(localStorage.getItem("is_save") == "1"){
                this.is_save = true;
            }else{
                this.is_save = false;
            }
        }
    },
    methods: {
        linkChange:function(event){
            // console.log(event.target.value);
            window.open(event.target.value)
        },
        newPage(path){
            window.open(path,'_blank');
        },
        terms:function(){
            location.href="/how_terms";
        },
        private_go:function(){
            location.href="/how_privacy";
        },
        saveIdpw:function() {
            if (this.is_save == true) {
                localStorage.setItem("email", this.info.email);
                localStorage.setItem("pw", this.info.pw);
                localStorage.setItem("is_save", "1");
            } else {
                localStorage.setItem("email", "");
                localStorage.setItem("pw", "");
                localStorage.setItem("is_save", "0");
            }
        },
        showPwpop:function() {
            // this.is_login = false;
            // this.pwVisible = true;
            alert("비밀번호 재설정을 희망하시면, 02-518-2603으로 연락 부탁 드립니다.");
        },
        vue_close:function(state) {
            this.pwVisible = state;
            this.is_login = true;
        },
        doSubmit:function() {
            var me = this;
            console.log(me.info.email);
            if (me.info.email == "") {
                this.is_err_id = true;
                return false;
            } else {
                this.is_err_id = false;
            }
            if (me.info.pw == "") {
                this.is_err_pw = true;
                return false;
            } else {
                this.is_err_pw = false;
            }

            if (this.is_save == true) {
                localStorage.setItem("email", this.info.email);
                localStorage.setItem("pw", this.info.pw);
                localStorage.setItem("is_save", "1");
            } else {
                localStorage.setItem("email", "");
                localStorage.setItem("pw", "");
                localStorage.setItem("is_save", "0");
            }

            var email = this.info.email;
            var password = this.info.pw;
            this.$store.dispatch('LOGIN', {
                    email,
                    password
                })
                .then(() => this.redirect())
                .catch(({
                    message
                }) => this.msg = message)
            console.log(this.msg);
        },
        redirect:function() {
            console.log("a");
            // this.$router.push("/intro")
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
// 폰트

@font-face {
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: normal;
}

@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&family=Roboto:wght@900&display=swap" rel="stylesheet');

// 공통
$point-color: #2a72ec;

* {
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

html {
    height: 100%;
}

body {
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: 300;
    font-size: 18px;
    margin: 0;
    height: 100%;
    color: #474341;
    word-break: keep-all;
}

button {
    font-family: 'Noto Sans KR', sans-serif;
}

.body {
    min-height: 100%;
    position: relative;
    padding-bottom: 70px;
    overflow-x:hidden
}

.wrap {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    position: relative;
}

.phone {
    display: none;
}

.phoneblock {
    display: none;
}

.phone-dp {
    display: inline-block;
}

input[type="text"],
input[type="password"],
select,
textarea {
    height: 45px;
    padding: 10px;
    border: 1px solid #ccc;
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 18px;

    &::placeholder {
        color: #a1a1a1;
        font-weight: 200;
    }
}

/*풋터*/
.footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #373737;
    color: #cecece;
    padding: 30px 0;
    .address {
        font-size: 13px;
        font-weight: 100;
        float: left;
        width: 50%;
        p {
            margin-top: 20px;
            margin-bottom: 20px;
            line-height: 25px;
            text-align: left;
        }
        select {
            border: none;
            padding: 5px 10px;
        }
    }

    .how_logo{
        text-align: left;
    }

    .how_logo_img{
        width: 150px;
        height: auto;
    }
    
    
    .follow{
        text-align: left;
    }

    .follow_icon{
        display: inline-block;
        margin-left: 10px;
        cursor: pointer;
    }
    
    .call {
        float: right;
        width: 45%;
        h3 {
            font-weight: bold;
            font-size: 18px;
        }
        .call-con {
            width: 100%;
            border-top: 1px solid #dadada;
            padding-top: 15px;
            text-align: left;


            .number {
                font-size: 25px;
                font-weight: 500;
            }
            .time {
                font-size: 13px;
                letter-spacing: 1px !important;
                span {
                    margin-right: 10px;
                }
            }
        }

        .call_tell{
            position: relative;
            height: 16px;
        }

        .call_email{
            position: relative;
            height: 16px;
        }

        .call_intro{
            position: relative;
            height: 16px;
            cursor: pointer;
        }

        .company_info{
            position: absolute;
            top: 53%;
            left:6%;
            transform: translateY(-50%);
            display: inline-block;
            font-size: 16px;
            line-height: 16px;
        }

        .company_icon_tell{
            display: inline-block;
            top: 2px;
            position: absolute;
        }

        .company_icon_email{
            display: inline-block;
            top: 4px;
            position: absolute;
        }

        .company_icon_intro{
            display: inline-block;
            top: 3px;
            position: absolute;
            width: 16px;
        }

        

        .family_site{
                height: 35px;
                padding: 5px;
                border: 1px solid #ccc;
                font-family: "Noto Sans KR", sans-serif;
                font-size: 15px;
        }
    }
}

/*상단네비*/
.main-navi {
    position: absolute;
    width: 100%;
    z-index: 54;
    .navi-wrap {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        h1 {
            float: left;
        }
        .pc-navi {
            float: right;
            li {
                display: inline-block;
                vertical-align: middle;
                font-size: 14px;
                font-weight: bold;
                position: relative;
                margin-top: 10px;
                &:last-child {
                    a {
                        padding-right: 0;
                    }
                }
                span {
                    display: block;
                    color: #fff;
                    padding: 15px 20px;
                }
                .pc-navi-dropmenu {
                    display: none;
                    position: absolute;
                    background: #fff;
                    z-index: 10;
                    left: -20px;
                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
                    -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
                    -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
                    li {
                        display: block;
                        &:hover {
                            background: #deebf1;
                        }
                        a {
                            display: block;
                            padding: 5px 40px;
                        }
                    }
                }
            }
        }
        .m-navi {
            display: none;
        }
        .m-navi-btn {
            display: none;
        }
    }
}

/*메인*/
.main-visual {
    background: #deebf1;
    background: url("../../assets/img/how/main_img.png") no-repeat left top;
    width: 100%;
    min-height: 680px;
    .how-title-wrap {
        padding-top: 200px;
        h2 {
            font-size: 40px;
            font-weight: bold;
            color: #fff;
        }
        h3 {
            color: #fff;
            padding-top: 15px;
            font-size: 20px;
        }
    }
}
.index-con {
    padding: 100px 0;
    h3 {
        font-size: 40px;
        font-weight: 700;
        margin-bottom: 30px;
        span {
            font-weight: 300;
        }
    }
    .how {
        position: relative;
        margin-bottom: 120px;
        .title {
            float: left;
            p {
                line-height: 30px;
            }
        }
        .visual {
            position: absolute;
            right: 0;
            top: -15px;
            z-index: -1;
        }
    }
    .how-test {
        text-align: center;
        padding: 0 0 120px 0;
        ul {
            li {
                display: inline-block;
                vertical-align: top;
                margin-right: 30px;
                &:last-child {
                    margin-right: 0px;
                }
                .title {
                    font-weight: bold;
                    font-size: 21px;
                    margin-bottom: 15px;
                }
            }
        }
    }
    .how-to {
        text-align: center;
        padding: 120px 0 120px 0;
        background: url(../../assets/img/how/how_to_img.png) no-repeat left top;
        color: #fff;
        .how-list {
            width: 1000px;
            margin: 50px auto 0 auto;
            .title {
                background: #52CAFF;
                padding: 15px 0;
                font-size: 20px;
                font-weight: bold;
                border-radius: 25px 25px 0 0;
            }
            .con-box {
                background: #fff;
                padding: 50px;
                border-radius: 0 0 25px 25px;
                p {
                    font-size: 18px;
                    color: #373737;
                    &.how-to-img {
                        padding-top: 20px;
                    }
                }
            }
        }
    }
    .how-process {
        width: 100%;
        padding: 120px 0 120px 0;
        text-align: center;
        h3 {
            margin-bottom: 50px;
        }
        ul {
            li {
                display: inline-block;
                vertical-align: top;
                padding: 0 14px;
                &:first-child {
                    padding-left: 0;
                }
                &:nth-child(2n) {
                    padding-top: 80px;
                }
                &:last-child {
                    padding-right: 0;
                }
                .title {
                    font-weight: bold;
                    font-size: 21px;
                    padding: 15px 0;
                }
                a {
                    font-size: 15px;
                    color: #005e9e;
                    font-weight: bold;
                    display: inline-block;
                    margin-top: 15px;
                    &::after {
                        display: block;
                        content: '';
                        border-bottom: 1px solid #005e9e;
                    }
                }
            }
        }
    }
    .how-index {
        text-align: center;
        padding: 120px 0 0 0;
        background: url(../../assets/img/how/how_platform.png) no-repeat left top;
        ul {
            width: 100%;
            text-align: left;
            margin-top: 48px;
            li {
                display: inline-block;
                &.txt {
                    width: 400px;
                    text-align: left;
                    vertical-align: top;
                    margin-top: 100px;
                    font-size: 20px;
                    .sub {
                        padding-top: 15px;
                    }
                }
                &.phone-img {
                    width: 796px;
                    margin-left: -300px;
                }
            }
        }
    }
    .how-class {
        text-align: center;
        padding: 120px 0 120px 0;
        background: url(../../assets/img/how/how_class_bg.png) no-repeat left top;
        color: #fff;
        background-size: cover;
        img{
            float: left;
            margin-top: 90px;
        }
        ul {
            // width: 1000px;
            width: 750px;
            margin: 50px auto 0 auto;
            margin-left: 54px;
            float: left;
            li {
                border-radius: 15px;
                background: #fff;
                color: #373737;
                padding: 20px;
                margin-bottom: 30px;
                p {
                    display: inline-block;
                    vertical-align: middle;
                    &.title {
                        width: 25%;
                    }
                    &.sub {
                        width: 74%;
                        // padding: 0 0 0 50px;
                        padding-left: 20px;
                        border-left: 1px dotted #999;
                        text-align: left;
                    }
                }
            }
        }
    }
}

// 로그인 레이어 팝업
.how-layer-bg {
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99999;
    overflow: auto;
    -ms-overflow-style: none;
    .how-layer {
        min-width: 500px;
        max-width: 600px;
        margin: 0 auto 50px auto;
        margin-top: 100px;
        background-color: #FFF;
        z-index: 9999;
        display: block;
        white-space: nowrap;
        position: relative;
        padding: 50px 0;
        .top {
            text-align: center;
            p {
                font-size: 16px;
            }
        }
        .layer-close {
            display: inline-block;
            position: absolute;
            right: 0px;
            top: -50px;
            img {
                width: 30px;
            }
        }
        .login-box {
            width: 80%;
            margin: 40px auto 00px auto;
            display: block;
            padding-bottom: 20px;
            .login-form {
                position: relative;
                margin-top: 10px;
                border: 1px solid #dadada;
                font-size: 15px;
                input {
                    &.input-login {
                        display: block;
                        width: 100%;
                        height: 40px;
                        padding: 0 15px;
                        border: 0;
                        font-weight: bold;
                        font-size: 15px;
                        line-height: 25px;
                        color: #1e1e1e;
                        vertical-align: top;
                        background-color: transparent;
                        outline: 0;
                    }
                }
                .txt-alert {
                    color: #ff6969;
                    font-size: 12px;
                    margin: 5px 0 10px 0;
                    display: none;
                }
            }
            .login-setting {
                margin-top: 10px;
                .lab-check {
                    font-size: 16px;
                }
            }
            .btn-login {
                width: 100%;
                padding: 13px 0;
                text-align: center;
                background: #404040;
                cursor: pointer;
                font-size: 16px;
                font-weight: bold;
                color: #ffffff;
                margin: 30px 0 0 0;
                border: none;
            }
            .login-rel {
                text-align: center;
                font-size: 16px;
                margin-top: 30px;
            }
        }
    }

}


// 반응형 시작

/*반응형 - 아이패드프로 (세로) 기준*/
@media only screen and (max-width: 1024px) {
    /*공통*/
    .body {
      min-height: 100%;
      position: relative;
      padding-bottom: 320px;
    }
    .wrap {
      width: 95%;
    }
    /*네비 (메인)*/
    .main-navi {
        .navi-wrap {
            width: 95%;
            padding: 10px 0;
            h1 {
                margin-top: 0;
                width: 150px;
                img {
                    width: 100%;
                }
            }
            .pc-navi {
                display: none;
            }
            .m-navi-btn {
                display: block;
                float: right;
                font-size: 16px;
                color: #fff;
                font-weight: bold;
                margin-top: 10px;
            }
            .m-navi {
                // position: absolute;
                position: fixed;
                top: 0;
                right: 0;
                z-index: 999;
                height: 100%;
                min-height: 100%;
                background: #fff;
                width: 310px;
                display: block;
                .m-navi-top {
                    display: block;
                    padding: 20px;
                    a {
                        // color: #fff;
                        float: right;
                    }
                }
                .m-navi-con {
                    .m-navi-li {
                        border-bottom: 1px solid #eeeeee;
                        a {
                            padding: 10px 20px;
                            display: block;
                        }
                    }
                }
            }
        }
    }
    .main-visual {
        .wrap {
            padding-top: 200px;
            .how-title-wrap {
                margin-top: 0;
                width: 90%;
                margin: 0 auto;
                text-align: center;
            }
        }
    }
    .index-con {
        .how-test {
            padding: 0 0 40px 0;
            ul {
                li {
                    margin-bottom: 30px;
                    width: 100%;
                    p {
                        &.title {
                            font-size: 18px;
                        }
                        &.sub {
                            font-size: 16px;
                        }
                    }
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .how-to {
            padding: 50px 0;
            .how-list {
                width: 100%;
                margin: 40px auto 0 auto;
                .title {
                    padding: 15px;
                    font-size: 18px;
                }
                .con-box {
                    padding: 20px;
                    p {
                        font-size: 16px;
                        &.how-to-img {
                            img {
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }
        .how-process {
            padding: 50px 0;
            ul {
                li {
                    width: 40%;
                    margin-right: 6%;
                    padding: 0;
                    img {
                        width: 100%;
                    }
                    &:nth-child(2n) {
                        display: none;
                    }
                    &:nth-child(3n) {
                        margin-right: 0;
                    }
                    .title {
                        font-size: 16px;
                    }
                }
            }
        }
        .how-index {
            padding: 50px 0 0 0;
            ul {
                width: 100%;
                text-align: left;
                margin-top: 30px;
                li {
                    &.txt {
                        width: 100%;
                        margin-top: 0;
                        text-align: center;
                        margin-bottom: 30px;
                        font-size: 20px;
                        p {
                            &.title {
                                width: 100%;
                            }
                            &.sub {
                                padding-top: 20px;
                                font-size: 16px;
                            }
                        }
                    }
                    &.phone-img {
                        width: 100%;
                        margin-left: 0;
                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }
        .how-class {
            padding: 50px 0;
            background-size: cover;
            .wrap{
                img{
                    width: 100%;
                    margin-top: 30px;
                }
            }
            ul {
                width: 100%;
                margin: 30px auto 0 auto;
                li {
                    padding: 20px;
                    margin-bottom: 30px;
                    p {
                        &.title {
                            width: 100%;
                            padding-bottom: 15px;
                            border-bottom: 1px dotted #999;
                        }
                        &.sub {
                            width: 100%;
                            padding: 0;
                            border-left: 0;
                            font-size: 16px;
                            text-align: center;
                            padding-top: 15px;
                        }
                    }
                }
            }
        }
    }

    /*레이어 팝업*/
    .how-layer-bg {
        .how-layer {
            min-width: 90%;
            max-width: 90%;
            margin: 50px auto;
            .layer-close {
                top: -40px;
            }
            .top {
                text-align: center;
                width: 90%;
                margin: 0 auto;
                p {
                    white-space: normal;
                    font-size: 14px;
                }
            }
            .login-box {
                width: 90%;
                margin: 30px auto 00px auto;
                .login-rel {
                    font-size: 14px;
                }
                .login-setting {
                    .lab-check {
                        font-size: 14px;
                    }
                }
            }
        }
    }
  }
  
  /*반응형 - 아이패드 기준*/
  @media only screen and (max-width: 768px) {
    /*공통*/
    .body {
      min-height: 100%;
      position: relative;
      padding-bottom: 320px;
    }
    .wrap {
      width: 95%;
    }
    /*메인*/
    .main-visual {
        min-height: 600px;
        background-position-x: center;
        background-size: cover;
        .wrap {
            width: 100%;
            padding-top: 0;
        }
        .how-title-wrap {
            h2 {
                font-size: 35px;
            }
        }
    }
    .index-con {
        padding: 60px 0 0px 0;
        h3 {
            font-size: 24px;
        }
        .how-test {
            p {
                font-size: 16px;
            }
        }
    }
    /*풋터*/
    .footer {
        .address {
            float: none;
            width: 100%;
        }

        .call {
            float: none;
            width: 100%;
            margin-bottom: 20px;
        }
    }

  }
  
  /*반응형 - 아이폰플러스 기준*/
  @media only screen and (max-width: 414px) {
    /*공통*/
    .m-br {
      display: block;
    }
    .phone-disnone {
      display: none !important;
    }
    .body {
      padding-bottom: 382px;
    }
  }
 
</style>
